<!--  -->
<template>
  <div class="safety-tools">
    <div class="row-content">
      <h2 class="title">Safety Tools</h2>
      <p class="content">We want all of our community members to have a positive experience on LivU, and that includes being as safe and secure as possible.</p>
      <p class="content">That’s why we have developed a number of seamless safety features in the app, including age verification, facial recognition, automatic content blurring and advanced content moderation.</p>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dt class="pc"><img src="../assets/images/m5-1.png" alt=""></dt>
        <dd class="margin-l">
          <p class="row-title">Always connect with a real person</p>
          <p class="row-p">When you match with another community member, both of you must have your face visible on camera. Otherwise, our technology will automatically blur your screen until a face appears. This makes sure that you always are connecting to a real person looking to make a connection. You can choose to unblur the other person’s screen when matching if they are not showing their face. </p>
        </dd>
        <dt class="mobile"><img src="../assets/images/m5-1.png" alt=""></dt>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-r">
          <p class="row-title">Automatic and manual content moderation</p>
          <p class="row-p">While we can’t control what all of our community does, we can help to make sure you’re not exposed to unpleasant or offensive content. Our automatic content moderation tools will end your video connection if your match displays content such as nudity, violence or offensive images – and for further security, we have a dedicated team ready to react.</p>
        </dd>
        <dt><img src="../assets/images/m5-2.png" alt=""></dt>
      </dl>
    </div>
    <div class="full-row" id="age">
      <dl class="img-text-warp">
        <dt class="pc"><img src="../assets/images/m5-3.png" alt=""></dt>
        <dd class="margin-l">
          <p class="row-title">Age verification when signing-up</p>
          <p class="row-p">Our community is only for those who are 18 years or older. To make sure of this, when you sign-up, whether it’s through Facebook, Google Play, the App store or by mobile number, your age will need to be verified.</p>
        </dd>
        <dt class="mobile"><img src="../assets/images/m5-3.png" alt=""></dt>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-r">
          <p class="row-title">Block and blacklist</p>
          <p class="row-p">If you have added a user, or they have directly messaged you, you can choose to block them at any time in your chat settings with that user. Once blocked they will be added to your blacklist, and you will be unable to receive messages from the user. If you wish to see who you have blocked, or to unblock a user, go to your profile settings and go to “Blacklist”. Here you can manage all the contacts you’ve blocked. </p>
        </dd>
        <dt>
          <switch-img :images="blockM54" :time="3"></switch-img>
        </dt>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dt class="pc"> <switch-img :images="blockM55" :time="3.5"></switch-img></dt>
        <dd class="margin-l">
          <p class="row-title">Manual reporting</p>
          <p class="row-p">You can easily report users in the app. To report a user in the app, you can either click the report symbol when matched or go into your chat history and report the user. To learn more about reporting a user <router-link to="/make-report">see here</router-link>.</p>
        </dd>
        <dt class="mobile"> <switch-img :images="blockM55" :time="3.5"></switch-img></dt>
      </dl>
    </div>
    <div class="row-footer">
      <h2 class="title">Disclaimers</h2>
      <p class="content">Screenshots may differ from your in-app experience. The material provided on this web page is intended for informational purposes only and may not be applicable in your country, region, or city. It is subject to change and may be updated without notice.</p>
    </div>
  </div>
</template>

<script>
import SwitchImg from './switch-img'
export default {
  name: 'safety-tools',
  data () {
    return {
      blockM54: [
        require('../assets/images/m5-4.png'),
        require('../assets/images/m5-4h.png')
      ],
      blockM55: [
        require('../assets/images/m5-5.png'),
        require('../assets/images/m5-5h.png')
      ]
    }
  },
  methods: {
  },
  components: {
    'switch-img': SwitchImg
  }
}

</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .safety-tools {
    .row-content {
      width: 970px;
      margin: 40px auto 0 auto;
      .title {
        font-size: 40px;
        line-height: 47px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        color: #6B6B6B;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 15px;
      }
    }
    .full-row {
      width: 100%;
      padding: 80px 0;
      &:nth-child(odd) {
        background-color: #FAFAFA;
      }
      .img-text-warp {
        width: 970px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        dt {
          flex-shrink:0;
          width: 348px;
          padding: 0 40px;
        }
        dd {
          text-align: left;
        }
        .row-title {
          font-size: 40px;
          line-height: 47px;
          font-weight: bold;
          color: #333;
          margin-bottom: 25px;
        }
        .row-p {
          color: #6B6B6B;
          font-size: 24px;
          line-height: 32px;
          margin-bottom: 15px;
        }
        .row-link {
          color: #1466ED;
          font-size: 24px;
        }
      }
    }
    .row-footer {
      width: 970px;
      margin: 30px auto 90px auto;
      .title {
        font-size: 40px;
        line-height: 47px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        color: #6B6B6B;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 15px;
      }
    }
    .margin-l {
      margin-left: 40px;
    }
    .margin-r {
      margin-right: 40px;
    }
    .mobile {
      display: none;
    }
  }
}
@media (max-width: 750px) {
  .safety-tools {
    .row-content {
      padding: 40px 25px 0 25px;
      .title {
        font-size: 22px;
        line-height: 26px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
      }
      .content {
        color: #6B6B6B;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 15px;
      }
    }
    .full-row {
      width: 100%;
      padding: 20px 25px;
      &:nth-child(odd) {
        background-color: #FAFAFA;
      }
      .img-text-warp {
        dt {
          padding: 0 80px;
          img {
            max-width: 100%;
          }
        }
        dd {
          text-align: left;
        }
        .row-title {
          font-size: 22px;
          line-height: 26px;
          font-weight: bold;
          color: #333;
          margin-bottom: 14px;
        }
        .row-p {
          color: #6B6B6B;
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 15px;
        }
        .row-link {
          color: #1466ED;
          font-size: 24px;
        }
      }
    }
    .row-footer {
      padding: 15px 25px 45px 25px;
      .title {
        font-size: 22px;
        line-height: 26px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        color: #6B6B6B;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 15px;
      }
    }
    .margin-l {
      margin-left: 0;
    }
    .margin-r {
      margin-right: 0;
    }
    .pc {
      display: none;
    }
  }
}
</style>
